// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import BibleReferenceSelectorController from "./bible_reference_selector_controller"
application.register("bible-reference-selector", BibleReferenceSelectorController)

import CopyLinkController from "./copy_link_controller"
application.register("copy-link", CopyLinkController)

import DestroyItemController from "./destroy_item_controller"
application.register("destroy-item", DestroyItemController)

import LinkifyController from "./linkify_controller"
application.register("linkify", LinkifyController)

import NestedAddController from "./nested_add_controller"
application.register("nested-add", NestedAddController)

import ShowAttachmentController from "./show_attachment_controller"
application.register("show-attachment", ShowAttachmentController)

import TextEditorController from "./text_editor_controller"
application.register("text-editor", TextEditorController)

import ToggleDisplayController from "./toggle_display_controller"
application.register("toggle-display", ToggleDisplayController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UploadMultipleController from "./upload_multiple_controller"
application.register("upload-multiple", UploadMultipleController)
